var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.945377L11.6349 5.17355L11.7489 5.35642L11.9601 5.39917L17.0118 6.42159L13.5886 10.0023L13.4279 10.1704L13.4529 10.4017L13.9746 15.2172L9.19041 13.2468L9 13.1684L8.80959 13.2468L4.02542 15.2172L4.54709 10.4017L4.57214 10.1704L4.41141 10.0023L0.988219 6.42159L6.03992 5.39917L6.25111 5.35642L6.36508 5.17355L9 0.945377Z",
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star_full.c9ff2e0aedb30809996ca576b2342a4f.svg";
export { ForwardRef as ReactComponent };